import { Injectable } from '@angular/core';
import {UiAdapterService} from "../uiAdapterService/ui-adapter.service";
import {Item} from "../../models/Item";
import {BehaviorSubject, fromEvent, merge, Subject} from "rxjs";
import {filter} from "rxjs/operators";
import {ObjectArrayPlugin} from '@src/app/classes/plugins/objectArrayPlugin/object-array-plugin';

const KEY_CODE_SHIFT = 16;

@Injectable({
  providedIn: 'root'
})
export class KeyListenersService {

  constructor(private ui: UiAdapterService) {
    this.initListeners();
  }

  private _currentDown$ = new BehaviorSubject(null);
  private _keyDown$: Subject<KeyboardEvent> = new Subject();

  get keyDown$(){
    return this._keyDown$.asObservable();
  }

  get currentDownKey(){
    return this._currentDown$.getValue();
  }
  get currentDown$(){
    return this._currentDown$.asObservable();
  }

  public hasKeyDown() {
    return !!this.currentDownKey;
  }

  public isShiftOnlyDown() {
    if (this.hasKeyDown()) {
      if (this.currentDownKey.which == KEY_CODE_SHIFT) {
        return true;
      }
    }
    return false;
  }

  private isFocusOnElement(){
    let tagNames = ['input', 'textarea', 'select'];
    return tagNames.includes(document.activeElement.tagName.toLowerCase());
  }

  private initListeners(){
    var keyActions = merge(fromEvent(document, 'keydown'), fromEvent(document, 'keyup'));

    keyActions.pipe(filter((event:KeyboardEvent) => { return event.type != 'keydown' || !this._currentDown$.getValue() || (this._currentDown$.getValue() && event.key != this._currentDown$.getValue().key)})).subscribe((e)=> {
      if (e.type === 'keyup'){
        return this.cleanUpDownKey();
      }
      return this._currentDown$.next(e);
    });

    fromEvent(document, 'keydown').subscribe((event: KeyboardEvent)=>{
      this._keyDown$.next(event)
    });

    fromEvent(window, 'blur').subscribe(_ => {
      this.cleanUpDownKey();
    });

    window.addEventListener('keydown', (e)=>{
      if (e.key == 'Delete' && this.ui.currentSelectedItem && !this.isFocusOnElement()){
        if (this.ui.currentSelectedItem instanceof Item) {
          let item = this.ui.currentSelectedItem;
          let confirmMessage = item.config.getInputProp('__objectArray', 'value') && item.config.copies ? Yiit.t('Are you sure? The whole array will be deleted.') : Yiit.t('Are you sure?');
          let isDel = confirm(confirmMessage);
          if (!isDel) return;
          this.ui.currentSelectedItem.removeObject();
        }
      }
    })
  }

  protected cleanUpDownKey () {
    return this._currentDown$.next(null);
  }
}

